import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BookingPassengersComponent} from '../../../shared/components/booking-passengers/booking-passengers.component';
import {BookingService} from '../../../shared/services/booking.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-engine-guests-modal',
  templateUrl: './engine-guests-modal.component.html',
  styleUrls: ['./engine-guests-modal.component.scss']
})
export class EngineGuestsModalComponent extends BookingPassengersComponent implements OnInit {

  // booleano per indicare se la modale viene aperta nella pagina di dettaglio del prodotto (holiday o cruise)
  @Input() isOpenIntoDetailPage: boolean;

  // evento per ritornare l'occupancy aggiornato
  @Output() selectedGuests = new EventEmitter();

  openForm: boolean;

  constructor(private _modalService: NgbModal,
              protected _bookingService: BookingService) {
    super(_bookingService);
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    // ritorno l'occupancy aggiornato (solo se nel metodo dove ho aperto la modale, effettuo un subscribe per recuperare il dato)
    this.selectedGuests.emit(this.occupancy);
    this._modalService.dismissAll();
    setTimeout(() => {
      const nextModalInput = document.getElementById("inputDestinationTour");
      if (nextModalInput) nextModalInput.click();
    }, 100);
  }

}
